export const USER_SIGN_OUT = 'APP/HEADER/USER_SIGN_OUT'
export const USER_SIGN_OUT_SUCCESS =
  'APP/HEADER/USER_SIGN_OUT_SUCCESS'
export const USER_SIGN_OUT_ERROR = 'APP/HEADER/USER_SIGN_OUT_ERROR'
export const SIGN_OUT_CLEAN_UP = 'APP/HEADER/SIGN_OUT/CLEAN_UP'
